export interface IIconActiveProps {
	isActive: boolean;
}
